import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import '@ar-js-org/ar.js/three.js/build/ar-threex.js';






// -------------------------------------
// -------- 3D CATALOG THREEJS  --------
// -------------------------------------

let canvas3DInstances = [];  // Mantener una lista de instancias de Canvas3D para controlarlas

class Canvas3D {

    constructor(canvasId, objectObj, objectObjTexture, offsetX, offsetY, offsetZ) {
        
        this.canvas = document.getElementById(canvasId);
        
        //this.objectFolder = objectFolder;
        this.objectObj = objectObj;
        this.objectObjTexture = objectObjTexture;
        
        this.offsetX = offsetX || 0;
        this.offsetY = offsetY || 0;
        this.offsetZ = offsetZ || 0;
        this.scene = null;
        this.camera = null;
        this.renderer = null;
        this.object = null;
        this.controls = null;
        this.animationFrameId = null;

        // Rango de zoom
        this.minZoom = 10;  // Valor mínimo de zoom
        this.maxZoom = 150;  // Valor máximo de zoom

        this.init();
    }

    init() {

        // Configuración de la escena
        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color(0xE9E9E9);
        
        if (this.canvas.id === "home3Dcanvas") {
            this.scene.background = new THREE.Color(0xFFFFFF);
        }

        // Configuración de la cámara
        this.camera = new THREE.PerspectiveCamera(40, this.canvas.clientWidth / this.canvas.clientHeight, 0.1, 1000);
        this.camera.position.z = 100; 
        //console.log("this.camera.position.z",this.camera.position.z)
        //console.log("this.offsetZ",this.offsetZ)
        this.camera.position.z += this.offsetZ;  // Ajustar la posición Z de la cámara

        //console.log("this.camera.position.z",this.camera.position.z)

        // Renderizador
        this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true });
        this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight);
    
        // Iluminación
        this.setupLights();

        // OrbitControls
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.25;
        this.controls.enableZoom = false;  // Desactivar el zoom mediante el mouse

        // Agregar evento para el slider de zoom
        const zoomSlider = document.getElementById('zoomSlider');
        if (zoomSlider) {

            zoomSlider.value = this.camera.position.z;

            zoomSlider.addEventListener('input', () => {

                const zoomLevel = parseFloat(zoomSlider.value);
                //console.log("zoomLevel",zoomLevel);
                this.camera.position.z = zoomLevel;  // Ajustar la posición Z de la cámara
                if (this.controls) {
                    this.controls.update();
                }

            });
        }

        // Cargar el objeto 3D
        this.loadObject();

        // Iniciar la animación
        this.animate();

        // Configurar el botón para alternar wireframe
        const toggleWireframeButton = document.getElementById('toggleWireframe');
        if (toggleWireframeButton) {
            toggleWireframeButton.addEventListener('change', () => {
                this.toggleWireframe();
            });
        }

    }

    setupLights() {
        const ambientLight = new THREE.AmbientLight(0xffffff, 1);
        this.scene.add(ambientLight);

        const leftLight = new THREE.DirectionalLight(0xffffff, 1);
        leftLight.position.set(-10, 5, 10);
        this.scene.add(leftLight);

        const rightLight = new THREE.DirectionalLight(0xffffff, 1);
        rightLight.position.set(10, 5, 10);
        this.scene.add(rightLight);

        const pointLight1 = new THREE.PointLight(0xffffff, 1, 100);
        pointLight1.position.set(0, 20, 0);
        this.scene.add(pointLight1);

        const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x000000, 0.5);
        this.scene.add(hemisphereLight);
    }

    loadObject() {
        const objLoader = new OBJLoader();
        const textureLoader = new THREE.TextureLoader();
        //const texturePath = `objects/${this.objectFolder}/${this.objectFolder}.jpg`;
        //const objPath = `objects/${this.objectFolder}/${this.objectFolder}.obj`;

        const texture = textureLoader.load(this.objectObjTexture);

        objLoader.load(this.objectObj, (loadedObject) => {
            loadedObject.traverse((child) => {
                if (child instanceof THREE.Mesh) {
                    // Material
                    const material = new THREE.MeshStandardMaterial({
                        map: texture,
                        metalness: 0.3,
                        roughness: 0.4,
                    });

                    child.material = material;
                }
            });

            //console.log("this.offsetY",this.offsetY)
            loadedObject.position.y += this.offsetY;
            loadedObject.position.x += this.offsetX;
            /*
            console.log("this.offsetZ",this.offsetZ)
            this.camera.position.z += this.offsetZ;  // Ajustar la posición Z de la cámara

            if (this.controls) {
                this.controls.update();
            }*/

            this.object = loadedObject;
            this.object.scale.set(0.5, 0.5, 0.5);

            if (this.canvas.id === "home3Dcanvas") {
                this.scene.background = new THREE.Color(0xFFFFFF);
                //this.object.rotation.x = -50 - (window.scrollY*0.001);
            }
    

            this.scene.add(this.object);
        });
    }

    animate() {
        this.animationFrameId = requestAnimationFrame(() => this.animate());

        if (this.object) {
            this.object.rotation.y += 0.01;
        }

        this.controls.update();
        this.renderer.render(this.scene, this.camera);
    }

    stop() {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
    }

    clearCanvas() {
        const context = this.canvas.getContext('2d', { willReadFrequently: true });
        if (context) {
            context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }
    }

    toggleWireframe() {
        if (this.object) {
            this.object.traverse((child) => {
                if (child instanceof THREE.Mesh) {
                    // Alternar entre el material normal y wireframe
                    child.material.wireframe = !child.material.wireframe;
                }
            });
        }
    }

    dispose() {
        // Detener la animación
        this.stop();
        // Limpiar la escena
        if (this.scene) {
            while (this.scene.children.length > 0) { 
                this.scene.remove(this.scene.children[0]); 
            }
        }
        // Limpiar el canvas
        this.clearCanvas();
        this.renderer.dispose();  // Liberar el renderizador
    }

    resize() {
        // Ajustar el tamaño del canvas y la cámara
        this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight);
        this.camera.aspect = this.canvas.clientWidth / this.canvas.clientHeight;
        this.camera.updateProjectionMatrix();
    }
}


// ----------------------------------------------------------------------------
// -------- CANVAS: FICHA DE INSTRUMENTO --------------------------------------
// ----------------------------------------------------------------------------

function initInstrumentCanvas() {
    const canvas = document.getElementById('instrument3D');
    if (canvas) {

        const objectObj = canvas.getAttribute('data-obj');
        const objectObjTexture = canvas.getAttribute('data-obj-texture');
        //const objectFolder = canvas.getAttribute('data-folder');
        const offsetX = parseFloat(canvas.getAttribute('data-offset-x')) || 0;
        const offsetY = parseFloat(canvas.getAttribute('data-offset-y')) || 0;
        const offsetZ = parseFloat(canvas.getAttribute('data-offset-z')) || 0;

        const instrumentCanvas = new Canvas3D('instrument3D', objectObj, objectObjTexture, offsetX, offsetY, offsetZ);

        // Ajustar el tamaño del canvas al redimensionar
        window.addEventListener('resize', () => {
            instrumentCanvas.resize();
        });
    }
}
//initInstrumentCanvas();




// ----------------------------------------------------------------------------
// -------- CANVAS: CATÁLOGO DE INSTRUMENTOS ----------------------------------
// ----------------------------------------------------------------------------

function initCatalogCanvases() {

    document.querySelectorAll('.article--instrument[data-obj]').forEach((item) => {

        const canvasId = item.getAttribute("data-canvas-id");
        //const objectFolder = item.getAttribute('data-folder');
        //const offsetY = parseFloat(item.getAttribute('data-offset-y')) || 0;

        const objectObj = item.getAttribute('data-obj');
        const objectObjTexture = item.getAttribute('data-obj-texture');

        const offsetX = parseFloat(item.getAttribute('data-offset-x')) || 0;
        const offsetY = parseFloat(item.getAttribute('data-offset-y')) || 0;
        const offsetZ = parseFloat(item.getAttribute('data-offset-z')) || 0;

        let canvas3DInstance = null;

        item.addEventListener('mouseenter', () => {
            canvas3DInstance = new Canvas3D(canvasId, objectObj, objectObjTexture, offsetX, offsetY, offsetZ);  // Inicializar el canvas y cargar el objeto
            canvas3DInstances.push(canvas3DInstance);  // Añadir la instancia a la lista
        });

        item.addEventListener('mouseleave', () => {
            if (canvas3DInstance) {
                canvas3DInstance.stop();
                canvas3DInstance.clearCanvas();
                canvas3DInstance = null;
            }
        });

        window.addEventListener('resize', () => {
            if (canvas3DInstance) {
                canvas3DInstance.resize();
            }
        });
    });

}



// ----------------------------------------------------------------------------
// -------- CANVAS AR: AUGMENTED REALITY  -------------------------------------
// ----------------------------------------------------------------------------

function stopAll3DInstances() {
    canvas3DInstances.forEach(instance => {
        instance.dispose();  // Limpiar cada instancia
    });
    canvas3DInstances = [];  // Vaciar la lista
}


function initInstrumentAR() {




}






// ----------------------------------------------------------------------------
// -------- FUNCIÓN: OBJETO 3D ALEATORIO EN HOME3D ----------------------------
// ----------------------------------------------------------------------------

function initHomeCanvas() {

    const home3DItems = Array.from(document.querySelectorAll('#home3Ddata .home3Ditem'));
    const canvasId = 'home3Dcanvas';

    let current3DIndex = null; // Índice del objeto actualmente cargado
    let canvas3DInstance = null;

    if (home3DItems.length === 0) {
        console.warn('No se encontraron objetos 3D para cargar.');
        return;
    }

    function loadRandom3DObject() {
        // Seleccionar un índice aleatorio que no sea el actual
        let randomIndex;
        do {
            randomIndex = Math.floor(Math.random() * home3DItems.length);
        } while (randomIndex === current3DIndex);

        current3DIndex = randomIndex;

        const selectedItem = home3DItems[randomIndex];

        const objectObj = selectedItem.getAttribute('data-obj');
        const objectObjTexture = selectedItem.getAttribute('data-obj-texture');
        console.log("objectObjTexture",objectObjTexture)
        const offsetX = parseFloat(selectedItem.getAttribute('data-offset-x')) || 0;
        const offsetY = parseFloat(selectedItem.getAttribute('data-offset-y')) || 0;
        const offsetZ = parseFloat(selectedItem.getAttribute('data-offset-z')) || 0;

        // Limpiar cualquier instancia previa
        if (canvas3DInstance) {
            canvas3DInstance.dispose();
        }

        // Crear una nueva instancia de Canvas3D con el objeto seleccionado
        canvas3DInstance = new Canvas3D(canvasId, objectObj, objectObjTexture, offsetX, offsetY, offsetZ);

    }

    // Cargar el primer objeto
    loadRandom3DObject();

    // Cambiar el objeto cada 3 segundos
    setInterval(() => {
        loadRandom3DObject();
    }, 10000);


    window.addEventListener('resize', () => {
        if (canvas3DInstance) {
            canvas3DInstance.resize();
        }
    });

    
    // Rotate on scrolling
    /*
    window.addEventListener('wheel', (event) => {

        if (window.scrollY <= 0) {
            return;
        }

        if (canvas3DInstance && event.deltaY !== 0) {
            const rotationSpeed = 0.002; // Adjust rotation speed
            canvas3DInstance.object.rotation.x -= event.deltaY * rotationSpeed;
        }
    });
    */


}









export { Canvas3D, initInstrumentCanvas, initCatalogCanvases, initInstrumentAR, initHomeCanvas, stopAll3DInstances };
